import React from 'react';
import { event } from '@uhg-abyss/web/tools/event';
import { SideTab } from '@src/common/SideTab';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

export const FeedbackTab = () => {
  return (
    <SideTab
      onClick={() => {
        return event('FEEDBACK');
      }}
      variant="outline"
      before={<IconSymbol icon="textsms" size={16} color="$primary1" />}
      offset={450}
    >
      Feedback
    </SideTab>
  );
};
